const isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i);
  },
  iOS: function () {
    return (navigator.userAgent.match(/iPhone|iPad|iPod/i) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
      !window.MSStream;
  },
  any: function () {
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};

const browserDetect = () => {
  let userAgent = navigator.userAgent;
  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
  }

  document.documentElement.classList.add(browserName);
};

const getScript = url => new Promise((resolve, reject) => {
  const script = document.createElement('script')
  script.src = url
  script.async = true

  script.onerror = reject

  script.onload = script.onreadystatechange = function () {
    const loadState = this.readyState

    if (loadState && loadState !== 'loaded' && loadState !== 'complete') return

    script.onload = script.onreadystatechange = null

    resolve()
  }

  document.head.appendChild(script)
});

// Устанавливает слайдер/видеоблок на всю высоту на главной
const setHeightSliderMain = () => {
  const sliderOnMain = document.querySelector('.slider-main');
  const videoOnMain = document.querySelector('.video-main');

  if (!sliderOnMain && !videoOnMain) return;

  const windowOuterHeight = window.outerHeight;
  const windowInnerHeight = window.innerHeight;
  const headerTopBlock = document.querySelector('.header__top-block').offsetHeight;
  const video = document.querySelector('.video-main__container');
  const searchForm = document.querySelector('.search-form');

  if (windowOuterHeight >= 670) {
    searchForm.style.position = 'absolute';

    if (sliderOnMain) {
      if (window.outerWidth < 768) {
        sliderOnMain.style.height = (windowInnerHeight - headerTopBlock) + 'px';
      } else {
        sliderOnMain.style.height = windowInnerHeight + 'px';
      }
    }

    if (videoOnMain && !videoOnMain.classList.contains('video-main--proportion')) {
      if (window.outerWidth < 768) {
        videoOnMain.style.height = (windowInnerHeight - headerTopBlock) + 'px';
        video.style.maxHeight = (windowInnerHeight - headerTopBlock) + 'px';
      } else {
        videoOnMain.style.height = windowInnerHeight + 'px';
        video.style.maxHeight = windowInnerHeight + 'px';
      }
    }
  } else {
    searchForm.style.position = 'static';

    if (sliderOnMain) {
      sliderOnMain.style.height = null;
    }

    if (videoOnMain) {
      videoOnMain.style.height = null;
      video.style.maxHeight = null;
    }
  }
};

// Плавный скролл до элемента
const setSmoothScroll = (elementID) => {
  const element = document.querySelector(elementID);
  const headerTopBlock = document.querySelector('.header__top-block');

  if (element) {
    const topOffset = (headerTopBlock) ? (headerTopBlock.clientHeight + 80) : 0;
    const elementPosition = element.offsetTop;
    const offsetPosition = elementPosition - topOffset;
    window.scrollTo({top: offsetPosition, behavior: 'smooth'});
  }
};

// Вычисление ширины полосы прокрутки
const getScrollbarWidth = () => {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.msOverflowStyle = 'scrollbar';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
};

// Компенсирование сдвига при скрытии полосы прокрутки
const compensateForScrollbar = (() => {
  let isCompensate = false;

  return function (isReset = false) {
    if (isReset) {
      isCompensate = true;
    }

    const scrollOffset = (!isCompensate) ? `${getScrollbarWidth()}px` : '';
    const offsetElementList = document.querySelectorAll('.compensate-for-scrollbar');
    document.body.style.marginRight = scrollOffset;

    offsetElementList.forEach((elem) => {
      elem.style.marginRight = scrollOffset;
    });

    return isCompensate = !isCompensate;
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  browserDetect();
  /* необходимо только в случае когда слайдер/видеоблок на всю высоту на главной странице
    setHeightSliderMain();
    window.addEventListener("resize", setHeightSliderMain);
  */
});

export {isMobile, getScript, setHeightSliderMain, setSmoothScroll, getScrollbarWidth, compensateForScrollbar};
